module.exports = __webpack_public_path__ + "static/media/icon-line-comic.83098501.svg";